interface TextArea {
  value: string;
  setValue: any;
  placeholder?: string;
  leadingIcon?: any;
  label?: string;
  labelDescription?: string;
  required?: boolean;
  disabled?: boolean;
}

const TextArea = ({
  value,
  setValue,
  placeholder,
  leadingIcon,
  label,
  labelDescription,
  required = false,
  disabled = false,
}: TextArea) => {
  return (
    <div>
      {label ? (
        <p
          className={`text-p-s dark:text-white font-medium ${
            !labelDescription ? "mb-2" : null
          }`}
        >
          {label}
          <>{required ? <span className="text-red-600">*</span> : null}</>
        </p>
      ) : null}
      {labelDescription ? (
        <p className="text-p-s text-neutral-600 dark:text-neutral-400 leading-tight mb-2">
          {labelDescription}
        </p>
      ) : null}

      <textarea
        className={`border dark:bg-neutral-900 dark:border-neutral-700 h-32 w-full rounded-md p-3 placeholder:text-neutral-400 flex-grow text-p-m dark:placeholder:text-neutral-500 ${
          disabled
            ? "bg-neutral-100 dark:bg-neutral-800 dark:text-neutral-400 text-neutral-500"
            : "dark:text-white"
        }
        `}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
};

export default TextArea;
